import { withInstall } from '../utils/type';
import ImgCheckbox from './ImgCheckbox.js';
import ImgCheckboxGroup from './img-checkbox-group';
ImgCheckbox.Group = ImgCheckboxGroup;
export { ImgCheckboxGroup };
export default withInstall(ImgCheckbox, ImgCheckboxGroup);